import { LinearGradient } from 'expo-linear-gradient';
import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { calcSizeForDevice } from 'utils/index';

import { Icons } from 'components/Icons';

type SectionArrowsProps = {
  side: 'right' | 'left';
  onPress: () => void;
  isVisible: boolean;
};

const SectionArrows: React.FC<SectionArrowsProps> = ({ side, onPress, isVisible }) => {
  const gradientColors = { right: ['#070d31', 'transparent'], left: ['transparent', '#070d31'] };
  const controllerVisibility = useBreakpointValueGS({ xl: 'flex', lg: 'flex', base: 'none' });
  const isRightSide = side === 'right';
  const iconsSize = {
    width: calcSizeForDevice(24, 32).toString(),
    height: calcSizeForDevice(24, 32).toString(),
  };

  return (
    <Pressable
      style={[
        styles.pressable,
        isRightSide ? styles.rightSide : styles.leftSide,
        !isVisible && styles.hidden,
      ]}
      onPress={onPress}>
      <LinearGradient
        end={{ x: 0, y: 0 }}
        start={{ x: 1, y: 0 }}
        tvParallaxShiftDistanceX={10}
        colors={gradientColors[side]}
        style={{ width: '100%', height: '100%', position: 'absolute', zIndex: 1 }}
      />

      <View style={[styles.iconContainer, { display: isVisible ? controllerVisibility : 'none' }]}>
        {isRightSide ? <Icons.ChevronRight {...iconsSize} /> : <Icons.ChevronLeft {...iconsSize} />}
      </View>
    </Pressable>
  );
};

export default SectionArrows;

const styles = StyleSheet.create({
  pressable: {
    width: calcSizeForDevice(64),
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
  },
  leftSide: {
    left: 0,
  },
  rightSide: {
    right: 0,
  },
  hidden: {
    display: 'none',
  },
  iconContainer: {
    zIndex: 2,
  },
});
